import { useEffect, useState, useCallback } from 'react';
import api from '../lib/api';
import { useAuth } from '../lib/auth';

/**
 * Iter 222: contador de recepciones anuladas en los últimos 7 días.
 * Solo para roles que pueden gestionar bodega (admin/gerencia/jefe_bodega).
 * Refresca cada 5 min y al volver a foco de la pestaña.
 */
export function useRecepcionesAnuladasCount() {
  const { user } = useAuth();
  const [count, setCount] = useState(0);

  const role = (user?.rol || user?.role || '').toLowerCase();
  const canSee = ['admin', 'administrador', 'gerencia', 'bodega_admin', 'jefe_bodega'].includes(role);

  const fetchCount = useCallback(async () => {
    if (!user || !canSee) return;
    try {
      const res = await api.get('/bodega/recepciones/anuladas-semana-count');
      setCount(res.data?.count || 0);
    } catch {
      setCount(0);
    }
  }, [user, canSee]);

  useEffect(() => {
    if (!user || !canSee) return;
    fetchCount();
    const interval = setInterval(fetchCount, 5 * 60 * 1000);
    const onFocus = () => fetchCount();
    window.addEventListener('focus', onFocus);
    return () => {
      clearInterval(interval);
      window.removeEventListener('focus', onFocus);
    };
  }, [user, canSee, fetchCount]);

  return count;
}
